// extracted by mini-css-extract-plugin
export default {"root":"style-module__root___LfO2C","root__text":"style-module__root__text___iVlL9","root__circle":"style-module__root__circle___TzV6T","root__done":"style-module__root__done___WAmnD","root__declined":"style-module__root__declined___mjOjT"};
    if(module.hot) {
      // 1697460472200
      var cssReload = require("../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  